export default "__VITE_ASSET__BJTOf1SZ__"